import { IProgramme, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

type Programme = {
  name: string;
  division_id: string;
};

interface ExportParams extends IqueryParams<{
  programme_name?: string;
  division_name?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createProgramme = async (data: Programme) => {
  return apiService.apiRequest<IProgramme>("post", `programmes`, data);
};

const getProgrammes = async (queryParams?: IqueryParams<{
  programme_name?: string;
  division_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IProgramme[]>("get", `programmes${query}`);
};

const getProgramme = async (programme_id: string) => {
  return apiService.apiRequest<IProgramme>("get", `programmes/${programme_id}`);
};

const updateProgramme = async (programme_id: string, data: Programme) => {
  return apiService.apiRequest<IProgramme>("put", `programmes/${programme_id}`, data);
};

const deleteProgramme = async (programme_id: string) => {
  return apiService.apiRequest<any>("delete", `programmes/${programme_id}`);
};

const restoreProgramme = async (programme_id: string) => {
  return apiService.apiRequest<any>(
    "get",
    `programmes/${programme_id}/restore`
  );
};

const exportProgrammes = async (params: ExportParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `programmes/export${query}`
  );
};

export const programmesApi = {
  createProgramme,
  getProgrammes,
  getProgramme,
  updateProgramme,
  deleteProgramme,
  restoreProgramme,
  exportProgrammes, 
};